// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  position: relative;
  padding: 35px 0px 10px;
  text-align: center;
}
.wrapper .cross {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
  cursor: pointer;
}
.wrapper .title {
  text-transform: uppercase;
  padding-bottom: 10px;
}
.wrapper .promo-img {
  margin: 0 auto;
  width: 150px;
  height: 150px;
  border: 1px solid var(--color-black);
  background: #F48B7F;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wrapper .promo-img ion-icon {
  width: 90px;
  height: 90px;
}
.wrapper .input-section {
  padding: 0px 25px;
  margin-bottom: 15px;
}
.wrapper .input-section ion-input {
  border-radius: 26px;
  border: 1px solid var(--color-black);
  --padding-start: 10px;
  --padding-end: 10px;
}
.wrapper .description {
  padding: 12px;
  text-transform: uppercase;
  padding: 20px;
}

.footer {
  padding-top: 10px;
  border-top: 1px solid var(--color-black);
}
.footer ion-button {
  width: 90%;
}

.error-message {
  color: #b30101;
  padding: 10px;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-promocode-modal/add-promocode-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,sBAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAER;AAAI;EACI,yBAAA;EACA,oBAAA;AAER;AAAI;EACI,cAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;AAGZ;AAAI;EACI,iBAAA;EAOA,mBAAA;AAJR;AAFQ;EACI,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;AAIZ;AAAI;EACI,aAAA;EACA,yBAAA;EACA,aAAA;AAER;;AACA;EACI,iBAAA;EACA,wCAAA;AAEJ;AADI;EACI,UAAA;AAGR;;AAAA;EACI,cAAA;EACA,aAAA;EACA,eAAA;AAGJ","sourcesContent":[".wrapper {\n    position: relative;\n    padding: 35px 0px 10px;\n    text-align: center;\n    .cross {\n        position: absolute;\n        top: 15px;\n        right: 15px;\n        width: 25px;\n        height: 25px;\n        z-index: 99;\n        cursor: pointer;\n    }\n    .title {\n        text-transform: uppercase;\n        padding-bottom: 10px;\n    }\n    .promo-img {\n        margin: 0 auto;\n        width: 150px;\n        height: 150px;\n        border: 1px solid var(--color-black);\n        background: #F48B7F;\n        border-radius: 26px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        ion-icon {\n            width: 90px;\n            height: 90px;\n        }\n    }\n    .input-section {\n        padding: 0px 25px;\n        ion-input {\n            border-radius: 26px;\n            border: 1px solid var(--color-black);\n            --padding-start: 10px;\n            --padding-end: 10px;\n        }\n        margin-bottom: 15px;\n    }\n    .description {\n        padding: 12px ;\n        text-transform: uppercase;\n        padding: 20px;\n    }\n}\n.footer {\n    padding-top: 10px;\n    border-top: 1px solid var(--color-black);\n    ion-button {\n        width: 90%;\n    }\n}\n.error-message {\n    color: #b30101;\n    padding: 10px;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
